import React from 'react';
import {
  AppContent,
  ErrorHandler,
  History,
  LoadingState,
} from '@common/components';
import { useQuery } from '@common/hooks';
import {
  InvoiceHistoryTab,
  InvoiceReviewQueryArgs,
  InvoiceReviewQueryResponse,
  RevInvoiceHistoryTab,
  RevInvoiceReviewQueryArgs,
  RevInvoiceReviewQueryResponse,
} from '@pay-bill/graphql';

export const BillingHistoryTab = ({
  id,
  isSupplier,
}: {
  id: string;
  isSupplier: boolean;
}) => {
  const {
    data: revInvoiceData,
    loading: revInvoiceLoading,
    error: revInvoiceError,
  } = useQuery<RevInvoiceReviewQueryResponse, RevInvoiceReviewQueryArgs>(
    RevInvoiceHistoryTab,
    {
      variables: { id },
      skip: !isSupplier,
    }
  );

  const {
    data: invoiceData,
    loading: invoiceLoading,
    error: invoiceError,
  } = useQuery<InvoiceReviewQueryResponse, InvoiceReviewQueryArgs>(
    InvoiceHistoryTab,
    {
      variables: { id },
      skip: isSupplier,
    }
  );

  const error = revInvoiceError || invoiceError;
  if (error) {
    return <ErrorHandler error={error} log="billing-hours-tab" />;
  }

  if (revInvoiceLoading || invoiceLoading) {
    return <LoadingState />;
  }

  const entity =
    invoiceData?.worksInvoice || revInvoiceData?.worksReverseInvoice;

  return (
    <AppContent left={false} right={false}>
      <History data={entity?.history} />
    </AppContent>
  );
};
